import FadeIn from '../fadeIn';
import { Replacer } from './replacer-main';

export abstract class ReplacerAbstract {
  protected replacer: Replacer;
  protected fadeIn: FadeIn | undefined;

  constructor(replacer: Replacer, fadeIn?: FadeIn) {
    this.replacer = replacer;
    this.fadeIn = fadeIn;
  }

  abstract replace(props: { data?: any; startOpacity?: number; [key: string]: any }): void;
}
